import { FaStopCircle } from "react-icons/fa";
import { PiStarFourFill } from "react-icons/pi";
import { Outlet, useLocation, useNavigate } from "react-router";

import { cn } from "@bentolabs/kit/utils";
import { useAccount } from "wagmi";

import { useTotalBalance } from "entities/balance/use-total-balance";
import { ConnectWalletButton } from "features/connect-wallet";
import { Layout } from "pages/ui/layout/layout";
import { Avatar } from "shared/ui/avatar";
import { Tab, Tabs } from "shared/ui/tabs";

export const Portfolio = () => {
  const { isConnected, address } = useAccount();
  const navigate = useNavigate();
  const location = useLocation();
  const isPointsPage = location.pathname.includes("/portfolio/points");

  const totalBalance = useTotalBalance();

  return (
    <Layout>
      <div className="mx-auto mt-16 mb-16 flex w-full max-w-5xl flex-col px-4">
        <header className="mx-auto flex flex-col items-center">
          {address ? (
            <Avatar className="size-20 rounded-[20px]" name={address} />
          ) : (
            <div className="bg-baltic-sea size-20 rounded-full" />
          )}

          <div
            className={cn("mt-5 text-[42px] leading-[115%]", "text-white/50")}
          >
            {totalBalance ?? 0}
          </div>
          <div className="text-nobel/70 mt-1 leading-[150%]">Total balance</div>
        </header>
        {!isConnected && (
          <div className="mt-7.5 flex flex-col items-center">
            <ConnectWalletButton />
          </div>
        )}
        {isConnected && (
          <Tabs className="mx-auto mt-9 gap-x-1.5">
            <Tab
              onClick={() => {
                navigate("/portfolio");
              }}
              isActive={!isPointsPage}
              className="w-auto max-w-40 min-w-36"
            >
              <FaStopCircle className="rotate-45" /> Assets
            </Tab>
            <Tab
              onClick={() => {
                navigate("/portfolio/points");
              }}
              isActive={isPointsPage}
              className="w-auto max-w-40 min-w-36"
            >
              <PiStarFourFill /> Points
            </Tab>
          </Tabs>
        )}
        <Outlet />
      </div>
    </Layout>
  );
};
